<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="名称/联系电话/联系地址"
             style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" size="small" style=" margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button type="primary" size="small" @click="addVehicleInfoModal=true">添加车辆信息</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="onFilterClick" @contextmenu.prevent.native="onTableRightClick($event)"
                 @on-cell-click="onCellClick"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true"
              show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>

    <Drawer title="历史记录" width="512"  :closable="false" v-model="historyRecordDrawer">
      <div v-for="item in historyRecord">
        <p>{{item}}</p>
      </div>
      <!--      <p>{{historyRecord}}</p>-->
    </Drawer>

    <add-vehicle-info-modal v-model="addVehicleInfoModal" @on-success="onSuccess"></add-vehicle-info-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <vehicle-picture-modal v-model="vehiclePictureModal" :initValue="vehiclePictureId"></vehicle-picture-modal>
    <business-note-detail-modal v-model="businessNoteDetailModal" :initValue="businessNoteInfo"
                                :showBusinessState="false"
                                @on-success="onModifySuccess"></business-note-detail-modal>
    <business-note-list-modal v-model="businessNoteListModal" :initValue="businessNoteListId"
                              @on-success="onModifySuccess"></business-note-list-modal>
    <change-business-user-modal v-model="changeBusinessUserModal" :initValue="changeBusinessUserVehicleInfoId"
                                @on-success="onModifySuccess"></change-business-user-modal>
    <assemble-positioning-device-modal v-model="assemblePositioningDeviceModal" :initValue="assembleVehicleInfoId"
                                       @on-success="onModifySuccess"></assemble-positioning-device-modal>
    <export-vehicle-cert-modal v-model="exportVehicleCertModal" :installed="exportVehicleCertInstalled"
                               :initValue="exportVehicleCertId"></export-vehicle-cert-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import AddVehicleInfoModal from '@/view/crm/components/add-vehicle-info-modal'
import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'
import VehiclePictureModal from '@/view/crm/components/vehicle-picture-modal'
import BusinessNoteDetailModal from '@/view/crm/components/business-note-detail-modal'
import BusinessNoteListModal from '@/view/crm/components/business-note-list-modal'
import ChangeBusinessUserModal from '@/view/crm/components/change-business-user-modal'
import AssemblePositioningDeviceModal from '@/view/im/components/assemble-positioning-device-modal'
import ExportVehicleCertModal from '@/view/crm/components/export-vehicle-cert-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

function calRegistrationTextColor (colorid) {
  if (colorid === 1) {
    return '#ffffff'
  } else if (colorid === 2) {
    return '#ffffff'
  } else if (colorid === 3) {
    return '#ffffff'
  } else if (colorid === 4) {
    return '#000000'
  } else if (colorid === 5) {
    return '#ffffff'
  } else {
    return '#000000'
  }
}

function calRegistrationColor (colorid) {
  if (colorid === 1) {
    return '#2b85e4'
  } else if (colorid === 2) {
    return '#ff9900'
  } else if (colorid === 3) {
    return '#1c2438'
  } else if (colorid === 4) {
    return '#f8f8f9'
  } else if (colorid === 5) {
    return '#009900'
  } else {
    return '#bbbec4'
  }
}

export default {
  name: 'usergroupvehicleinfos',
  components: {
    VehiclePictureModal,
    AddVehicleInfoModal,
    VehicleInfoDetailModal,
    BusinessNoteDetailModal,
    BusinessNoteListModal,
    ChangeBusinessUserModal,
    AssemblePositioningDeviceModal,
    ExportVehicleCertModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      businessUserFilter: null,
      gdcdgovVehicleStateFilter: null,
      ucdlysjgtdgdgovStateFilter: null,
      hasBindServiceDevicesFilter:null,
      marketsales: null,

      // 配置设备
      assemblePositioningDeviceModal: false,
      assembleVehicleInfoId: null,

      // 指定业务跟进
      changeBusinessUserModal: false,
      changeBusinessUserVehicleInfoId: null,

      // 图片管理
      vehiclePictureModal: false,
      vehiclePictureId: null,

      // 添加收入项
      addVehicleInfoModal: false,

      // 车辆信息详细信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      // 导出证明
      exportVehicleCertModal: false,
      exportVehicleCertId: null,
      exportVehicleCertInstalled: false,

      // 业务笔记
      businessNoteDetailModal: false,
      businessNoteInfo: {
        id: null,
        businessState: null,
        content: null,
        updateDatetime: null,
        vehicleInfoId: null
      },

      // 业务笔记列表
      businessNoteListModal: false,
      businessNoteListId: null,

      //历史记录列表
      historyRecordDrawer: false,
      historyRecord: null,

      pageFilter: 30,
      pagesizeopts:[30, 50,100,200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      totalElements: 0,
      content: [],
      pageSize: 30,
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '车牌',
          resizable: true,
          key: 'registrationNum',
          ellipsis: 'true',
          width: 120,
          sortable: 'custom',
          render: function (h, params) {
            let registrationNum = params.row.registrationNum
            if (params.row.customName) {
              registrationNum = registrationNum + '(' + params.row.customName + ')'
            }
            return h('div', {
              props: {
                disabled: false
              },
              style: {
                'text-align': 'center',
                backgroundColor: calRegistrationColor(params.row.registrationColor),
                color: calRegistrationTextColor(params.row.registrationColor)
              },
              on: {
                click: () => {
                  // this.onRegistrationNOClick(params.row)
                }
              }
            }, registrationNum)
          }
        },
        {
          title: '定位服务',
          resizable: true,
          key: 'hasBindServiceDevices',
          ellipsis: 'true',
          width: 140,
          filters: this.HasBindServiceDevicesType,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.hasBindServiceDevicesFilter = []
              val.forEach(item => {
                this.hasBindServiceDevicesFilter.push(genQueryParam('hasBindServiceDevices', 'EQ', item))
              })
            } else {
              this.hasBindServiceDevicesFilter = null
            }
          },
          render: function (h, params) {
            const hasBindServiceDevices = params.row.hasBindServiceDevices
            if (hasBindServiceDevices) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    size: 'small',
                    color: 'green'
                  }
                }, '已安装设备')
              ])
            } else {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    size: 'small',
                    color: 'red'
                  }
                }, '无定位设备')
              ])
            }
          }
        },
        {
          title: '广东省厅数据状态',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 190,
          filters: [
            { label: '无资料', value: 0 },
            { label: '正常', value: 1 },
            { label: '运营商不符', value: 2 },
            { label: '非营运', value: 3 },
            { label: '定位时间不符', value: 4 },
            { label: '非运政车辆', value: 5 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.gdcdgovVehicleStateFilter = []
              val.forEach(item => {
                this.gdcdgovVehicleStateFilter.push(genQueryParam('gdcdgovVehicleState', 'EQ', item))
              })
            } else {
              this.gdcdgovVehicleStateFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            let gdcdgovVehicleState = params.row.gdcdgovVehicleState
            if (gdcdgovVehicleState === 0) {
              return h('div', '无资料')
            } else if (gdcdgovVehicleState === 1) {
              return h('div', '正常')
            } else if (gdcdgovVehicleState === 2) {
              return h('div', '运营商不符')
            } else if (gdcdgovVehicleState === 3) {
              return h('div', '非营运')
            } else if (gdcdgovVehicleState === 4) {
              return h('div', '定位时间不符')
            } else if (gdcdgovVehicleState === 5) {
              return h('div', '非运政车辆')
            }
          }
        },
        {
          title: '智能监管系统',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 190,
          filters: [
            { label: '无资料', value: 0 },
            { label: '正常', value: 1 },
            { label: '未上传过卫星定位,未上传过报警,未上传过附件', value: 2 },
            { label: '未上传过报警,未上传过附件', value: 3 },
            { label: '未上传过附件', value: 4 },
            { label: '设备停止服务', value: 5 },
            { label: '非视频机设备', value: 6 },
            { label: '定位时间不符', value: 7 },
            { label: '无绑定设备', value: 8 },
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.ucdlysjgtdgdgovStateFilter = []
              val.forEach(item => {
                this.ucdlysjgtdgdgovStateFilter.push(genQueryParam('ucdlysjgtdgdgovState', 'EQ', item))
              })
            } else {
              this.ucdlysjgtdgdgovStateFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            let ucdlysjgtdgdgovState = params.row.ucdlysjgtdgdgovState
            if (ucdlysjgtdgdgovState === 0) {
              return h('div', '无资料')
            } else if (ucdlysjgtdgdgovState === 1) {
              return h('div', '正常')
            } else if (ucdlysjgtdgdgovState === 2) {
              return h('div', '未上传过卫星定位,未上传过报警,未上传过附件')
            } else if (ucdlysjgtdgdgovState === 3) {
              return h('div', '未上传过报警,未上传过附件')
            } else if (ucdlysjgtdgdgovState === 4) {
              return h('div', '未上传过附件')
            } else if (ucdlysjgtdgdgovState === 5) {
              return h('div', '设备停止服务')
            } else if (ucdlysjgtdgdgovState === 6) {
              return h('div', '非视频机设备')
            } else if (ucdlysjgtdgdgovState === 7) {
              return h('div', '定位时间不符')
            }
          }
        },
        {
          title: '客户/分组名',
          resizable: true,
          key: 'vehicleInfoGroupId',
          sortable: 'custom',
          ellipsis: 'true',
          minWidth: 180,
          render: (h, params) => {
            let display = []
            if (params.row.clientInfo) {
              display.push(h('div', '客户信息:' + params.row.clientInfo.name + '(' + params.row.clientInfo.phoneNum + ')'))
            } else {
              display.push(h('div', '客户信息:无'))
            }
            if (params.row.vehicleInfoGroup) {
              display.push(h('div', '分组:' + params.row.vehicleInfoGroup.name))
            } else {
              display.push(h('div', '分组:无'))
            }
            return h('div', display)
          }
        },
        {
          title: '车架号',
          resizable: true,
          key: 'vin',
          sortable: 'custom',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '车辆类型',
          resizable: true,
          key: 'vehicleTypeId',
          ellipsis: 'true',
          width: 180,
          render: (h, params) => {
            if (params.row.vehicleType) {
              return h('label', params.row.vehicleType.name)
            }
          }
        },
        {
          title: '发动机号',
          resizable: true,
          key: 'engineNum',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '定位设备',
          resizable: true,
          ellipsis: 'true',
          width: 350,
          render: (h, params) => {
            let positioningDeviceInfos = params.row.positioningDeviceInfos
            if (positioningDeviceInfos && positioningDeviceInfos.length > 0) {
              let d = []
              positioningDeviceInfos.forEach(item => {``
                let display = ''
                let displaySims = null
                let adas = item.positioningDeviceModel.adas ? '(视频机)' : '(非视频机)'
                display = display + item.positioningDeviceModel.name + adas + ':'
                if (item.simInfos && item.simInfos.length > 0) {
                  displaySims = ''
                  item.simInfos.forEach(item => {
                    displaySims = displaySims + item.simNum
                  })
                  displaySims = displaySims.substr(0, displaySims)
                  display = display + item.terminalNum + '[SIM卡号:' + displaySims + ']'
                } else {
                  display = display + item.terminalNum
                }
                display = display + '(到费期:' + new Date(item.serviceDatetime).Format('yyyy年MM月dd日') + ')'
                d.push(h('div', display))
              })
              // display = display.substr(0, display.length - 1)
              return h('div', d)
            } else {
              return h('div', '未安装')
            }
          }
        },
        {
          title: '跟进业务员',
          resizable: true,
          key: 'businessUserId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.businessUserFilter = []
              val.forEach(item => {
                this.businessUserFilter.push(genQueryParam('businessUserId', 'EQ', item))
              })
            } else {
              this.businessUserFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.businessUser) {
              let name = null
              if (params.row.businessUser.realName) {
                name = params.row.businessUser.realName
              } else if (params.row.businessUser.nickName) {
                name = params.row.businessUser.nickName
              } else if (params.row.businessUser.name) {
                name = params.row.businessUser.name
              }
              return h('div', name)
            }
          }
        },
        {
          title: '历史记录',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          // tooltip: 'true',
          key: 'historyRecord',
          width: 200
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          width: 450,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehicleInfoDetailId = params.row.id
                    this.vehicleInfoDetailModal = true
                  }
                }
              }, '详细信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehiclePictureId = params.row.id
                    this.vehiclePictureModal = true
                  }
                }
              }, '图片管理'),
              h('Button', {
                props: {
                  type: params.row.businessNoteCount >0 ? 'success' : 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    // this.businessNoteInfo.vehicleInfoId = params.row.id
                    // this.businessNoteInfo.id = params.row.businessNoteId
                    // this.businessNoteDetailModal = true

                    this.businessNoteListModal = true
                    this.businessNoteListId = params.row.id

                  }
                }
              }, '业务笔记'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    if (!params.row.vehicleOwnerInfoId) {
                      this.$Message.error('缺少车辆所有人信息')
                      return
                    }
                    this.exportVehicleCertInstalled = true
                    this.exportVehicleCertId = params.row.id
                    this.exportVehicleCertModal = true
                  }
                }
              }, '导出证明'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.assembleVehicleInfoId = params.row.id
                    this.assemblePositioningDeviceModal = true
                  }
                }
              }, '配置设备'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.changeBusinessUserVehicleInfoId = params.row.id
                    this.changeBusinessUserModal = true
                  }
                }
              }, '指定业务跟进')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'VehicleInfoServ_GetMyUserGroupPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '跟进业务员') {
          this.columns[i].filters = this.marketsales
          break
        }
      }
    },
    //单击单元格
    onCellClick(row, column, data, event){
      // console.log(row)
      // console.log(column)
      // console.log(data)
      // console.log(event)
      if (column.key == "historyRecord") {
        let datas = data.split('\n');
        // console.log(datas)
        this.historyRecordDrawer = true
        this.historyRecord = datas
      }
    },
    onFilterClick () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let qo5 = null
      let qo6 = null
      let qo7 = null
      let qo8 = null

      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.businessUserFilter) {
        qo5 = this.businessUserFilter
      }
      if (this.gdcdgovVehicleStateFilter) {
        qo6 = this.gdcdgovVehicleStateFilter
      }
      if (this.ucdlysjgtdgdgovStateFilter) {
        qo7 = this.ucdlysjgtdgdgovStateFilter
      }
      if(this.hasBindServiceDevicesFilter){
        qo8 = this.hasBindServiceDevicesFilter
      }

      store.dispatch('VehicleInfoServ_GetMyUserGroupPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo5: qo5,
          qo6: qo6,
          qo7: qo7,
          qo8: qo8,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        if (store.getters.get_VehicleInfo_GetMyUserGroupPageResult) {
          this.totalElements = store.getters.get_VehicleInfo_GetMyUserGroupPageResult.totalElements
          this.content = store.getters.get_VehicleInfo_GetMyUserGroupPageResult.content
          this.pageSize = store.getters.get_VehicleInfo_GetMyUserGroupPageResult.size
        } else {
          this.totalElements = 0
          this.content = []
          this.pageSize = 0
        }
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    // totalElements() {
    //   if (store.getters.get_VehicleInfo_GetPageResult) {
    //     return store.getters.get_VehicleInfo_GetPageResult.totalElements
    //   } else {
    //     return 0
    //   }
    // },
    // content() {
    //   if (store.getters.get_VehicleInfo_GetPageResult) {
    //     return store.getters.get_VehicleInfo_GetPageResult.content
    //   } else {
    //     return []
    //   }
    // },
    // pageSize() {
    //   if (store.getters.get_VehicleInfo_GetPageResult) {
    //     return store.getters.get_VehicleInfo_GetPageResult.size
    //   } else {
    //     return 0
    //   }
    // }
  },
  mounted () {
    this.$nextTick(() => {
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [7] }
      }).then(() => {
        let marketsales = store.getters.get_User_GetAllUsersResult
        this.marketsales = marketsales.map(item => {
          return { label: item.realName, value: item.id }
        })
        // this.columns[4].filters = this.installers
        // this.columns[13].filters = this.marketsales
        this.onColumnUpdate()
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
